import { CampaignStatus } from "@types";

export const isActive = (status: CampaignStatus): boolean => {
  return status === CampaignStatus.Active;
};
